export class LoginModelRequest {

        "username": String;
        "password": String;
        "deviceToken": String;
        "platform": String;
        "roleId": Number

}